module.exports = __webpack_public_path__ + "img/searchEmpty.155afb30.png";